export default {
  // Navigation
  'nav.home': 'ホーム',
  'nav.product': '製品紹介',
  'nav.cases': '成功事例',
  'nav.findDoctor': '保護者ガイド',
  'nav.about': '会社概要',
  'nav.doctorLogin': '医師ログイン',
  
  // Common
  'common.learnMore': '詳細を見る',
  'common.contactUs': 'お問い合わせ',
  'common.submit': '送信',
  'common.search': '検索',
  
  // Footer
  'footer.quickLinks': 'クイックリンク',
  'footer.contact': 'お問い合わせ',
  'footer.followUs': 'フォローする',
  'footer.copyright': '© 2024 Mirókids. 全著作権所有.',
  'footer.phone': '電話',
  'footer.email': 'メール',
  'footer.address': '住所',
};
